import axios from "axios";
import { ROLES_URL } from "../../API/Api";

const getRoles = async (token) => {
  const headers = {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  };
  const response = await axios({
    method: "GET",
    baseURL: `${ROLES_URL}`,
    headers: headers,
    params: { return_all: "1" },
  });
  return response.data;
};

const rolesService = {
  getRoles,
};

export default rolesService;
